<div class="p-8"> 
    <div [innerHTML]="cargoInfo"></div>
</div>